import { runtimeConfig } from '@/lib';

export const isProd = typeof window === 'undefined' ? true : runtimeConfig.BUILD_TYPE === 'prod';
